import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { displayRequestEducationTable } from "../display-request-education-table";
import { translate as t } from "../../../infrastructure/translate/localization";
import SectionContentWrapper from "../../../app/components/SectionContentWrapper";
import TabSelector from "../../../app/components/TabSelector";
import reviewRentingRequests from "../review-renting-requests";
import TableDataSpinner from "../../../app/components/modals/employee/DeleteEmployeesModal/components/TableDataSpinner";
import { findCompanyDetail } from "../../../infrastructure/repository/company-repository";

const tabs = {
  formation: {
    title: t("benefits-section.education-benefit.education"),
    content: <Grid item xs={12} id="table-request-education-container" />,
    useCase: displayRequestEducationTable,
  },
  renting: {
    title: t("common-messages.renting"),
    content: <Grid item xs={12} id="renting-requests-table-container" />,
    useCase: reviewRentingRequests,
  },
};

export default function RequestsPage({ selectedTab }) {
  const [currentTab, setCurrentTab] = useState(selectedTab);
  const [isRentingChecked, setIsRentingChecked] = useState(false);
  const [disabledBenefitList, setDisabledBenefitList] = useState([]);

  useEffect(() => {
    async function checkRentingRequest() {
      const companyData = await findCompanyDetail();
      const enabled =
        companyData.data.benefitConfigs?.["renting-benefit"]?.enabled;
      if (!enabled) {
        setDisabledBenefitList((state) => [...state, "renting"]);
      }
      setIsRentingChecked(true);
    }
    checkRentingRequest();
  }, []);

  if (tabs[currentTab]) {
    tabs[currentTab].useCase();
  }

  const filterTabsToDisplay = () =>
    Object.keys(tabs)
      .filter((key) => !disabledBenefitList.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: tabs[key],
        };
      }, {});

  return (
    <main className="section">
      <SectionContentWrapper
        title={t("request-section.request")}
        rightContent={
          <div className="section-header">
            <div id="notification-card" />
          </div>
        }
      >
        {isRentingChecked ? (
          <TabSelector
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            options={Object.keys(filterTabsToDisplay()).map((key) => ({
              ...tabs[key],
              tabName: key,
            }))}
          />
        ) : (
          <TableDataSpinner />
        )}
      </SectionContentWrapper>
    </main>
  );
}

RequestsPage.defaultProps = {
  selectedTab: "formation",
};

RequestsPage.propTypes = {
  selectedTab: PropTypes.string,
};
